import {
	getUserProperty,
	setUserProperty,
} from '@jira/admin-pages__performance/src/setUserProperty.tsx';

const PROPERTY_KEY = 'jira.user.settings.system.site-optimizer-spotlight';

export const hasSeenSiteOptimiserSpotlight = async (accountId: string) => {
	const response = await getUserProperty({
		accountId,
		propertyKey: PROPERTY_KEY,
		defaultValue: false,
	});
	// If they have not seen the spotlight, return true and mark as shown
	if (!response.value) {
		await setUserProperty({
			accountId,
			propertyKey: PROPERTY_KEY,
			propertyValue: true,
		});
		return false;
	}
	return true;
};
